const $inject = ['$timeout'];

const focusOn = function ($timeout) {
  return {
    restrict: 'A',
    scope: {
      focusOn: '<',
      focusOnly: '@',
    },
    link: function ($scope, $element, $attr) {
      $scope.$watch('focusOn', function (_focusVal) {
        $timeout(function () {
          if (_focusVal) {
            $element[0].focus();
          } else if (!$scope.focusOnly) {
            $element[0].blur();
          }
        });
      });
    },
  };
};

focusOn.$inject = $inject;

export default focusOn;



// WEBPACK FOOTER //
// ./src/directives/focusOn.js